import React, { useState, useEffect, useRef } from 'react';
import { getImageSize } from '../../helpers/image';

const Image = ({ src, alt, size = 'MEDIUM', className = '', progressive = false, width='100%'}) => {
  const [imageSrc, setImageSrc] = useState(progressive ? null : getImageSize(src, size));
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  const handleError = () => {
    setImageSrc(src);
  };

  const handleLoad = () => {
    setLoaded(true);
  };
  useEffect(() => {
    if (!progressive) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setImageSrc(getImageSize(src, size));
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: '40px 0px', 
        threshold: 0.01,
      },
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) observer.unobserve(imgRef.current);
    };
  }, [src, size, progressive]);

  return (
    <>
      {progressive ? (
        <div ref={imgRef}>
          <img
            className={`${className} ${!loaded ? 'd-none' : ''}`}
            src={imageSrc}
            alt={alt}
            onError={handleError}
            onLoad={handleLoad}
          />
        </div>
      ) : (
        <img
          className={`${className} ${!loaded ? 'd-none' : ''}`}
          src={imageSrc}
          alt={alt}
          onError={handleError}
          onLoad={handleLoad}
        />
      )}

      <div
        className={loaded ? 'd-none' : 'd-inline-block'}
        style={{
          backgroundColor: 'transparent',
          width:width,
          aspectRatio: '1',
          objectFit: 'cover',
        }}
      />
    </>
  );
};

export default Image;
